/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { combineReducers } from 'redux'
import toasts from '@redux/slices/toasts'
import modal from '@redux/slices/modal'
import ui from '@redux/slices/ui'
import common from '@redux/slices/common'
import event from '@redux/slices/event'
import dashboard from '@redux/slices/dashboard'
import deployment from '@redux/slices/deployment'
import oidc from '@redux/slices/oidc'
import api from '@redux/apis/baseApi'
import {
  c1Common,
  c1Accounts,
  c1Services,
  c1UserDetails,
  c1Token,
} from './c1State'

export default combineReducers({
  // C1C Redux State
  c1Common,
  c1Accounts,
  c1Services,
  c1UserDetails,
  c1Token,
  // FSS Redux State
  ui,
  deployment,
  dashboard,
  common,
  toasts,
  modal,
  event,
  oidc,
  [api.reducerPath]: api.reducer,
})
